import { render, staticRenderFns } from "./TranslationSettingsView.vue?vue&type=template&id=38a00e83&scoped=true"
import script from "./TranslationSettingsView.vue?vue&type=script&lang=js"
export * from "./TranslationSettingsView.vue?vue&type=script&lang=js"
import style0 from "./TranslationSettingsView.vue?vue&type=style&index=0&id=38a00e83&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a00e83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a00e83')) {
      api.createRecord('38a00e83', component.options)
    } else {
      api.reload('38a00e83', component.options)
    }
    module.hot.accept("./TranslationSettingsView.vue?vue&type=template&id=38a00e83&scoped=true", function () {
      api.rerender('38a00e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/translation-settings/TranslationSettingsView.vue"
export default component.exports